import api from '../api';
import { toast } from 'react-toastify';
import messageTypes from '../../constants/MessagesTypes';

export async function getOperators(companyId, data) {
  return api.get(`/api/user/operators`, {
    params: {
      companyId,
      ...data
    },
    headers: {
      auth: true
    },
  }).catch((error) => {
    toast.error(messageTypes.ERROR_LOAD);
    return [];
  });
}

export async function createOperator(data) {
  return api.post(`/api/user/operator/new`, data, {
    headers: {
      'Content-Type': 'application/json',
      auth: true
    },
  }).catch((error) => {
    toast.error(error.response?.data?.message || messageTypes.ERROR_SAVE);
    throw error;
  });
}

export async function updateOperator(id, data) {
  return api.put(`/api/user/operator/${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      auth: true
    },
  }).catch((error) => {
    toast.error(error.response?.data?.message || messageTypes.ERROR_UPDATE);
    throw error;
  });
}

export async function getOperator(id) {
  return api.get(`/api/user/operator/${id}`, {
    headers: {
      auth: true
    },
  }).catch((error) => {
    toast.error(error.response?.data?.message || messageTypes.ERROR_LOAD);
    throw error;
  });
}

export async function deleteOperator(id) {
  return api.delete(`/api/user/operator/${id}`, {
    headers: {
      auth: true
    },
  }).catch((error) => {
    toast.error(error.response?.data?.message || messageTypes.ERROR_DELETE);
    throw error;
  });
}


